import { Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { deleteDoctor, getAllDoctors } from '../../../../api/transports';
import useFetchList from '../../../../hooks/useFetchList';
import { fetchDoctorTypes } from '../../../../redux/slices/transports';
import { useDispatch, useSelector } from '../../../../redux/store';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { locationColumns } from '../../../../reusable-components/datagrid/locationColumns';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import LocationModal from '../Shared/LocationModal';

export default function Locations() {
  const { enqueueSnackbar } = useSnackbar();
  const [refreshKey, setRefreshKey] = useState(1);
  const [locations, locationsLoading, locationsError] = useFetchList(getAllDoctors, [refreshKey], []);
  const transportsState = useSelector((state) => state.transports);
  const facilities = transportsState?.data?.facilities ?? [];
  const facilityDataIsLoading = transportsState?.isLoading ?? false;
  const doctorTypes = transportsState?.data?.doctorTypes ?? [];
  const dispatch = useDispatch();

  useEffect(() => {
    if (doctorTypes.length === 0) {
      dispatch(fetchDoctorTypes());
    }
  }, [dispatch, doctorTypes.length]);

  // Preprocess locations to add facilityName and doctorTypeName
  const processedLocations = locations.map((location) => {
    const facility = facilities.find((f) => f.value === location.facilityId);
    const doctorType = doctorTypes.find((dt) => dt.id === location.doctorTypeId);
    return {
      ...location,
      facilityName: facility ? facility.label : '',
      doctorTypeName: doctorType ? doctorType.name : '',
    };
  });

  const customToolbar = useCallback(
    () => (
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end">
        <LocationModal onAdded={() => setRefreshKey((k) => k + 1)} />
      </Grid>
    ),
    []
  );

  const handleDelete = async (doctorId) => {
    try {
      const response = await deleteDoctor(doctorId);
      const result = response.data;
      if (result.success) {
        enqueueSnackbar('Location deleted successfully', { variant: 'success' });
        setRefreshKey((k) => k + 1);
      } else {
        enqueueSnackbar(result.message || 'Failed to delete Location', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to delete Location', { variant: 'error' });
    }
  };

  const ActionButtons = (params) => (
    <>
      <LocationModal edit row={params.row} onAdded={() => setRefreshKey((k) => k + 1)} />

      {/* <ConfirmDialog
        icon="delete-outline"
        title="Delete"
        color="error"
        content={`Are you sure you want to delete this location?`}
        actionButton="Delete"
        action={() => handleDelete(params.row.id)}
        tooltip={`Delete`}
      /> */}
    </>
  );

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    width: 180,
    renderCell: (params) => ActionButtons(params),
    id: 'actions',
    className: 'actions',
  };

  return (
    <>
      <Grid item xs={12}>
        <CustomDataGrid
          gridId="transports-locations"
          boxSX={{ height: 'calc(100vh - 225px)' }}
          data={processedLocations}
          gridColumns={[...locationColumns, actions]}
          CustomLeftToolbar={customToolbar}
          getRowId={(row) => `${row.id}`}
          isLoading={facilityDataIsLoading || locationsLoading}
        />
      </Grid>
    </>
  );
}
